import { Box, useMediaQuery, useTheme } from "@mui/material";

const TrainAnimation = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
 const fontSize = isSmallScreen ? '50%' : isMediumScreen ? '75%' : '100%';
  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          animation: 'moveTrain 20s linear infinite',
          //fontSize: isSmallScreen ? '1.2rem' : isMediumScreen ? '1.5rem' : '2rem',
          fontSize: fontSize,
        }}
      >
        🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃🚃
        <span style={{ display: 'inline-block', transform: 'scaleX(-1)', fontSize: '100%' }}>
  🚂
</span>

      </Box>
      <style>
        {`
          @keyframes moveTrain {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }
        `}
      </style>
    </Box>
  );
};

export default TrainAnimation;
